export const OAUTH_SET_TOKEN = 'OAUTH_SET_TOKEN';
export const OAUTH_REMOVE_TOKEN = 'OAUTH_REMOVE_TOKEN';